import axios from 'axios';
import api from './api';

// Base URL for the external AI backend (Railway)
export const AI_BASE_URL = 'https://aibackend-production-901c.up.railway.app';

const aiApi = axios.create({
  baseURL: AI_BASE_URL,
  // Let backend handle CORS; include withCredentials as false for cross-origin
  withCredentials: false,
});

// Schedules optimization: accepts .xer file
export const scheduleOpt = async (file: File) => {
  const formData = new FormData();
  formData.append('file', file);
  const res = await aiApi.post('/schedule_opt', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return res;
};

// Video analyzer: accepts .xer file and video
export const videoAnalyzer = async (file: File, video: File) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('video', video);
  const res = await aiApi.post('/video_analyzer', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return res;
};

// Status: accepts task_id and data_key
export const checkStatus = async (task_id: string, data_key: string) => {
  // Route through our backend proxy to avoid browser CORS and handle auth
  const res = await api.post('/ai/status', { task_id, data_key });
  return res;
};

// Delay analysis: accepts .xer file
export const delayAnalysis = async (file: File) => {
  const formData = new FormData();
  formData.append('file', file);
  const res = await aiApi.post('/delay', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return res;
};

// Overall report: accepts .xer file and optional images[]
export const overallReport = async (file: File, images: File[] = []) => {
  const formData = new FormData();
  formData.append('file', file);
  images.forEach((img) => formData.append('images', img));
  const res = await aiApi.post('/overall_report', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return res;
};

// Risk forecast: accepts .xer file
export const riskForecast = async (file: File) => {
  const formData = new FormData();
  formData.append('file', file);
  const res = await aiApi.post('/risk_forecast', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return res;
};

export default aiApi;